{
  "loading": "로드 중…",
  "placeholder": "선택…"
}
